<app-form-requests           
    [indexList] = "indexList"
    [systemList] = "systemList"
    [propertiesList] = "propertiesList"
    [propBskList] = "propBskList"
    [customEditorList]="editorList"
    [groupList]="groupList"
    [userList]="userList"
    [resultList]="resultList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-requests>
